// extracted by mini-css-extract-plugin
export default {"appContainer":"Contact_appContainer__JElD4","glow":"Contact_glow__D7PBu","contact":"Contact_contact__1zc6p"};